import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dayforceKeys } from './keys'
import {
  createContestedHoursRequest,
  type CreateContestedHoursRequest,
} from 'api/admin/dayforce/createContestedHoursRequest'

export const useCreateContestedHoursRequestMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: CreateContestedHoursRequest) =>
      createContestedHoursRequest(request),
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      }),
  })
}
